export function useDispatchAirportFieldEvent(dispatch, isNearbySelected, suggestionInputValue) {
  const dispatchEvent = ({
    type,
    value
  }) => {
    let isDefaultPrevented = false;
    dispatch({
      type,
      payload: {
        value,
        suggestionInputValue,
        isNearbySelected,
        valid: true
      },
      preventDefault: () => {
        isDefaultPrevented = true;
      }
    });
    return {
      isDefaultPrevented
    };
  };
  return dispatchEvent;
}